import { all, call, put, takeLatest } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import api from '../../services/api';
import {
  LIST_PLURALL_IMPORT_ISSUES_REQUEST,
  RESOLVE_PLURALL_UNMATCHED_REQUEST,
  RESOLVE_PLURALL_PROCESS_ISSUE_REQUEST,
} from '../actions';
import {
  listPlurallImportIssuesRequest,
  listPlurallImportIssuesSuccess,
  listPlurallImportIssuesError,
  resolvePlurallUnmatchedSuccess,
  resolvePlurallUnmatchedError,
  resolvePlurallProcessIssueSuccess,
  resolvePlurallProcessIssueError,
} from './actions';
import getApiErrors from '../../helpers/getApiErrors';

function buildQueryParams(filters) {
  const params = new URLSearchParams();
  params.set('class_id', filters.class_id);

  if (filters.cycle_is) {
    params.set('cycle_is', String(filters.cycle_is));
  }
  if (filters.subject_id) {
    params.set('subject_id', filters.subject_id);
  }
  if (filters.subarea_id) {
    params.set('subarea_id', filters.subarea_id);
  }

  return params.toString();
}

function listPayloadWithoutMeta(payload) {
  const { fetchKey, ...filters } = payload;
  return filters;
}

function* listPlurallImportIssues({ payload }) {
  const { fetchKey } = payload;
  const filters = listPayloadWithoutMeta(payload);

  try {
    const query = buildQueryParams(filters);
    const response = yield call(api.get, `plurall/import-issues?${query}`);
    yield put(
      listPlurallImportIssuesSuccess({
        data: response.data.data,
        fetchKey,
      })
    );
  } catch (error) {
    const message =
      error?.response?.data?.message || error?.message || 'Erro ao carregar problemas.';
    yield put(listPlurallImportIssuesError({ message, fetchKey }));
    getApiErrors(error?.response?.data ?? error);
  }
}

function* resolvePlurallUnmatched({ payload }) {
  const { id, class_id, cycle_is, subject_id, subarea_id } = payload;

  try {
    yield call(api.post, `plurall/import-issues/unmatched/${id}/resolve`);
    yield put(resolvePlurallUnmatchedSuccess());
    toast.success('Aluno marcado como resolvido.');
    yield put(
      listPlurallImportIssuesRequest({
        class_id,
        cycle_is,
        subject_id,
        subarea_id,
        fetchKey: buildQueryParams({ class_id, cycle_is, subject_id, subarea_id }),
      })
    );
  } catch (error) {
    yield put(resolvePlurallUnmatchedError(error));
    getApiErrors(error?.response?.data ?? error);
  }
}

function* resolvePlurallProcessIssue({ payload }) {
  const { id, class_id, cycle_is, subject_id, subarea_id } = payload;

  try {
    yield call(api.post, `plurall/import-issues/process/${id}/resolve`);
    yield put(resolvePlurallProcessIssueSuccess());
    toast.success('Erro do processo removido.');
    yield put(
      listPlurallImportIssuesRequest({
        class_id,
        cycle_is,
        subject_id,
        subarea_id,
        fetchKey: buildQueryParams({ class_id, cycle_is, subject_id, subarea_id }),
      })
    );
  } catch (error) {
    yield put(resolvePlurallProcessIssueError(error));
    getApiErrors(error?.response?.data ?? error);
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(LIST_PLURALL_IMPORT_ISSUES_REQUEST, listPlurallImportIssues),
    takeLatest(RESOLVE_PLURALL_UNMATCHED_REQUEST, resolvePlurallUnmatched),
    takeLatest(RESOLVE_PLURALL_PROCESS_ISSUE_REQUEST, resolvePlurallProcessIssue),
  ]);
}
